import { render } from "./MIndex.vue?vue&type=template&id=aa1d4e48&scoped=true"
import script from "./MIndex.vue?vue&type=script&lang=js"
export * from "./MIndex.vue?vue&type=script&lang=js"

import "./MIndex.vue?vue&type=style&index=0&id=aa1d4e48&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa1d4e48"]])

export default __exports__